import type {
  OwnedRoute,
  OwnedSidebarItem,
  OwnedSidebarSection,
} from './admin-extension-contract'

type OwnedIds = {
  sectionIds: Set<string>
  itemIds: Set<string>
  routeIds: Set<string>
}

export const sidebarSectionById = new Map<string, OwnedSidebarSection>()
export const sidebarItemById = new Map<string, OwnedSidebarItem>()
export const routeById = new Map<string, OwnedRoute>()
export const routeByKey = new Map<string, OwnedRoute>()
export const routeByPath = new Map<string, OwnedRoute>()
export const ownedIdsByPlugin = new Map<string, OwnedIds>()
export const unresolvedRouteKeyDiagnostics = new Set<string>()
export const unresolvedRoutePathDiagnostics = new Set<string>()

export const clearRouteResolutionDiagnostics = () => {
  unresolvedRouteKeyDiagnostics.clear()
  unresolvedRoutePathDiagnostics.clear()
}

export const registerOwnedIds = (pluginId: string): OwnedIds => {
  const existing = ownedIdsByPlugin.get(pluginId)
  if (existing) return existing
  const created = {
    sectionIds: new Set<string>(),
    itemIds: new Set<string>(),
    routeIds: new Set<string>(),
  }
  ownedIdsByPlugin.set(pluginId, created)
  return created
}

export const removeOwnedByPluginId = (pluginId: string) => {
  const ownership = ownedIdsByPlugin.get(pluginId)
  if (!ownership) return null

  const removedSections = ownership.sectionIds.size
  const removedItems = ownership.itemIds.size
  const removedRoutes = ownership.routeIds.size

  ownership.itemIds.forEach((itemId) => {
    sidebarItemById.delete(itemId)
  })
  ownership.sectionIds.forEach((sectionId) => {
    sidebarSectionById.delete(sectionId)
  })
  ownership.routeIds.forEach((routeId) => {
    const route = routeById.get(routeId)
    if (route) {
      routeByKey.delete(route.key)
      routeByPath.delete(route.routePath)
    }
    routeById.delete(routeId)
  })
  ownedIdsByPlugin.delete(pluginId)

  return {
    removedSections,
    removedItems,
    removedRoutes,
  }
}

export const clearAdminExtensionStore = () => {
  sidebarSectionById.clear()
  sidebarItemById.clear()
  routeById.clear()
  routeByKey.clear()
  routeByPath.clear()
  ownedIdsByPlugin.clear()
  clearRouteResolutionDiagnostics()
}

